import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { booleanBodyRender, TableColumn } from '@app/components/common/table';
import { Warehouse } from '@app/api/models/distributor';


export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: Warehouse) => void;
}): TableColumn[] => [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'code',
    label: 'Код',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'name',
    label: 'Название',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'distributor_id',
    label: 'Дистрибьютор (id)',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'warehouse_type_id',
    label: 'Тип склада (id)',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'address',
    label: 'Адрес',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'is_active',
    label: 'Активен',
    options: {
        // filter: {
        //   type: 'boolean',
        // },
      sort: true,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'id',
    label: 'Действия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, { rowData }) => (
        <Flex gap={2}>
          <IconButton
            aria-label="edit"
            onClick={() => onEdit(rowData as Warehouse)}
          >
            <MdEdit />
          </IconButton>
        </Flex>
      ),
    },
  },
];
